import { ParceiroApi } from "@/api/facturacao/ParceiroApi";

export class ClienteApi extends ParceiroApi {
  protected readonly grupo = "Cliente" as const;
}
